import React from 'react';
import { View } from 'react-native';
import Svg, { Path, Rect } from 'react-native-svg';

const PasswordIcon = ({ color, height, width }) => {
    return (
        <View>
            <Svg
                width={width}
                height={height}
                viewBox="0 0 48 48"
                fill="none"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <Path d="M24,25.28a3.26,3.26,0,0,0-1.64,6.07V36h3.32V31.35a3.28,3.28,0,0,0,1.61-2.8v0A3.27,3.27,0,0,0,24,25.28Z" />
                <Rect x="7.38" y="17.77" width="33.23" height="25.73" rx="4.32" />
                <Path d="M13.35,17.77V15.16a10.66,10.66,0,0,1,21.32,0v2.61" />
            </Svg>
        </View>
    );
};

export default PasswordIcon;
